import { COLORS_CONFIG, COLORS_CONFIG_BAR } from '@components/widgets/apacheEchart/Commons'
import { answeredMapper, invalidMapper, isGeoLocationLeaf } from '../dashHelper'
import { getCommonWidget } from '../dashWidgetHelper'
import { getLineDetailedRadar } from '../widgetsLibrary/widgetsLine'
import { commonWidgets, MITSUBISHI_SCALE_3_COLORS} from './commonWidgetsMitsu'

const getAllWidgets = (filters: FiltersUI, filtersData: Record<string, any>) => {
  return [
    getLineDetailedRadar({
      mainIndicator: 'POSVENTA_SATISFACCION',
      radialIndicators: [
        'POSVENTA_SATISFACCION',
        'POSVENTA_NPS',
        'POSVENTA_AMABILIDAD_PERSONAL',
        'POSVENTA_RECEPCION_VEHICULO',
        'POSVENTA_EXPLICACION_TRABAJO'
      ],
      radialType: 'byIndicator',
      position: [0, 0],
      size: [4, 3],
      title: 'Satisfacción General',
      groupByLevel: 2,
      extraConfigs: {
        backgroundColor: 'transparent',
        theme: 'dark',
        showRadialChart: true,
        initialVisibleChart: 1,
        /* maxValue: 10, */
      },
      useNormalizedRadial: true,
      normalizeBottom: 0,
      normalizeTop: 10,
      criticalMomentInclude: [2],
      indicatorsNames: {
        'POSVENTA_SATISFACCION': 'Satisfacción',
        'POSVENTA_AMABILIDAD_PERSONAL': 'Amabilidad',
        'POSVENTA_EXPLICACION_TRABAJO': 'Explicacion Final',
        'POSVENTA_NPS': 'NPS',
        'POSVENTA_RECEPCION_VEHICULO': 'Bienvenida',
      },
    }),
    //1
    {
      title: 'Encuestas',
      type: 'label',
      position: [0, 3],
      size: [2, 1],
      config: { color: '#B7AADC' },
    },
    {
      title: 'Alertas',
      type: 'label',
      position: [2, 3],
      size: [2, 1],
      config: { color: '#B7AADC' },
    },
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'surveyCountTrendByMonth',
      position: [0, 4],
      size: [1, 2],
      indicator: 'survey-response-counters',
      criticalMomentId: 2,
      extras:{
              sort: { sortBy: 'group', value: 'asc' }
            }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'surveyCountTrendByWeek',
      position: [1, 4],
      size: [1, 2],
      indicator: 'survey-response-counters',
      criticalMomentId: 2,
      extras:{
              sort: { sortBy: 'group', value: 'asc' }
            }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'alertsTrendByMonth',
      position: [2, 4],
      size: [1, 2],
      indicator: 'ALERT_FIRST_RESPONSE_TIME',
      criticalMomentId: 2,
      extras:{
              sort: { sortBy: 'group', value: 'asc' }
            }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'alertsTrendByWeek',
      position: [3, 4],
      size: [1, 2],
      indicator: 'ALERT_FIRST_RESPONSE_TIME',
      criticalMomentId: 2,
      extras:{
            sort: { sortBy: 'group', value: 'asc' }
          }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'multipleTrendByMonth',
      title: 'widgets.npsPostventa',
      position: [0, 6],
      size: [1, 2],
      indicator: 'POSVENTA_NPS',
      criticalMomentId: 2,
      extras: {
        periods: 6
      },
      extraConfigs: {
        useCurrent: 0,
        colors: MITSUBISHI_SCALE_3_COLORS
      }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGeneric',
      title: 'widgets.snPostventa',
      position: [1, 6],
      size: [1, 2],
      indicator: 'POSVENTA_SATISFACCION',
      criticalMomentId: 2,
      extraConfigs: {
        maxValue: 10
      }
    }),
    /* getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGenericByStatus',
      title: 'widgets.calidadDatosPostventa',
      position: [2, 6],
      size: [1, 2],
      mapper: invalidMapper,
      url: 'survey-responses/values',
      criticalMomentId: 2
    }), */
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGenericByStatus',
      title: 'widgets.porcRespuestasPostventa',
      position: [2, 6],
      size: [1, 2],
      mapper: answeredMapper,
      url: 'survey-responses/values',
      criticalMomentId: 2
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'multipleGaugeByQuestion',
      title: 'widgets.customerJourneyPostventa',
      position: [0, 8],
      size: [4, 2],
      indicator: 'POSVENTA_CUSTOMER_JOURNEY',
      criticalMomentId: 2,
      extraConfigs: {
        maxValue: 5
      }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByQuestionBest',
      title: 'widgets.bestRotativasPostventa',
      position: [0, 10],
      size: [2, 2],
      indicator: 'POSVENTA_ROTATIVAS',
      criticalMomentId: 2
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByQuestionWorst',
      title: 'widgets.worstRotativasPostventa',
      position: [2, 10],
      size: [2, 2],
      indicator: 'POSVENTA_ROTATIVAS',
      criticalMomentId: 2
    }),
    //3
    {
      title: 'Oficinas',
      type: 'label',
      position: [0, 12],
      size: [4, 1],
    },
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'mapByGeos',
      title: 'Mapa de oficinas',
      position: [0, 13],
      size: [2, 2],
      indicator: 'POSVENTA_SATISFACCION',
      criticalMomentInclude: [2, 11703],
      extraConfigs: {
        bestLocationValueFrom: 9,
        worstLocationValueTo: 9
      }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByGeoBest',
      title: 'widgets.bestGeoLocationsPostventa',
      position: [2, 13],
      size: [1, 2],
      extraConfigs: {
        backgroundColor: '#501C78',
        titleBackgroundColor: '#88DD76',
        symbol: ''
      },
      indicator: 'POSVENTA_SATISFACCION',
      criticalMomentInclude: [2, 11703],
      render: (filters) => {
        return !isGeoLocationLeaf(filters, filtersData)
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByGeoWorst',
      title: 'widgets.worstGeoLocationsPostventa',
      position: [3, 13],
      size: [1, 2],
      extraConfigs: {
        backgroundColor: '#501C78',
        titleBackgroundColor: '#db7476',
        symbol: ''
      },
      indicator: 'POSVENTA_SATISFACCION',
      criticalMomentInclude: [2, 11703],
      render: (filters) => {
        return !isGeoLocationLeaf(filters, filtersData)
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingPositionHighestScope',
      title: 'widgets.rankingPositionHighestScope',
      position: [2, 13],
      size: [2, 1],
      extraConfigs: {
        backgroundColor: '#501C78',
        titleBackgroundColor: '#88DD76',
        symbol: ''
      },
      indicator: 'POSVENTA_SATISFACCION',
      criticalMomentInclude: [2, 11703],
      render: (filters) => {
        return isGeoLocationLeaf(filters, filtersData)
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingPositionLowestScope',
      title: 'widgets.rankingPositionLowestScope',
      position: [2, 14],
      size: [2, 1],
      extraConfigs: {
        backgroundColor: '#501C78',
        titleBackgroundColor: '#88DD76',
        symbol: ''
      },
      indicator: 'POSVENTA_SATISFACCION',
      criticalMomentInclude: [2, 11703],
      render: (filters) => {
        return isGeoLocationLeaf(filters, filtersData)
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByTagBest',
      title: 'widgets.bestTagsPostventa',
      position: [0, 15],
      size: [2, 1],
      indicator: 'sentiment',
      criticalMomentId: 2,
      extras: {
        trunc: 'HALF_DOWN',
        topSize: 3,
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByTagWorst',
      title: 'widgets.worstTagsPostventa',
      position: [0, 16],
      size: [2, 1],
      indicator: 'sentiment',
      criticalMomentId: 2,
      extras: {
        resultType: 'bottom',
        trunc: 'HALF_UP',
        bottomSize: 3,
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'wordCountWithLinksSinDefaults',
      title: 'Nube de Palabras / Frecuencia en comentarios',
      position: [2, 15],
      size: [2, 2],
      indicator: 'WORD_COUNT_WITH_LINKS',
      criticalMomentId: 2,
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'textAnalysis',
      title: 'widgets.sentimentAnalysis',
      position: [0, 17],
      size: [4, 3],
      criticalMomentId: 2,
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'diagramaIshikawa',
      title: 'Diagrama Ishikawa',
      position: [0, 20],
      size: [4, 3],
      indicator: 'sentiment',
      criticalMomentId: 2,
    }),
    {
      title: 'widgets.otherIndicators',
      type: 'label',
      position: [0, 23],
      size: [4, 1],
    },
    {
      title: 'widgets.appointmentPostventa',
      // [Column, Row]
      position: [0, 24],
      size: [2, 2],
      config: {
        id: 'posventa-puntualidad',
        type: 'pie',
        colors: ['#015c52', '#33b9ce', '#f38625'],
        fillMode: '',
        showValues: true,
        //percentageScale: false,
        mapper: (data: any) => {
          return data.map((item: any) => ({
            id: item['group'] == null ? 'Indefinido' : item['group'],
            label: item['group'] == null ? 'Indefinido' : item['group'],
            value: item['value'],
          }))
        },
        indicators: [
          {
            indicator: 'POSVENTA_AGENDAR_CITA',
            //grouped: 'geoLocation',
            keyExtract: ['group', 'count', 'value'],
            label: 'group',
            value: 'value',
            singleton: true,
            extras: {
              criticalMomentId: 2,
            },
          },
        ],
      },
    },
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGeneric',
      key: 'posventa-instalaciones',
      title: 'widgets.waitingRoomPostventa',
      position: [2, 24],
      size: [1, 2],
      indicator: 'POSVENTA_INSTALACIONES',
      criticalMomentId: 2,
      extraConfigs: {
        maxValue: 5,
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGeneric',
      key: 'posventa-senaletica',
      title: 'widgets.signagePostventa',
      position: [3, 24],
      size: [1, 2],
      indicator: 'POSVENTA_SENIALECTICA',
      criticalMomentId: 2,
      extraConfigs: {
        maxValue: 5,
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGeneric',
      key: 'posventa-facturacion',
      title: 'widgets.paymentPostventa',
      position: [0, 26],
      size: [1, 2],
      indicator: 'POSVENTA_FACTURACION',
      criticalMomentId: 2,
      extraConfigs: {
        maxValue: 5,
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGeneric',
      key: 'posventa-vehiculo-sustitucion',
      title: 'widgets.substitutionCarPostventa',
      position: [1, 26],
      size: [1, 2],
      indicator: 'POSVENTA_VEHICULO_SUSTITUCION',
      criticalMomentId: 2,
      extraConfigs: {
        maxValue: 5,
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGeneric',
      key: 'posventa-limpieza-vehiculo',
      title: 'widgets.carStatusPostventa',
      position: [2, 26],
      size: [1, 2],
      indicator: 'POSVENTA_LIMPIEZA_VEHICULO',
      criticalMomentId: 2,
      extraConfigs: {
        maxValue: 5,
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGeneric',
      key: 'posventa-reparacion',
      title: 'widgets.repairPostventa',
      position: [3, 26],
      size: [1, 2],
      indicator: 'POSVENTA_REPARACION_VEHICULO',
      criticalMomentId: 2,
      extraConfigs: {
        maxValue: 5,
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGeneric',
      key: 'posventa-disponibilidad',
      title: 'widgets.repairAvailablePostventa',
      position: [0, 28],
      size: [1, 2],
      indicator: 'POSVENTA_DISPONIBILIDAD_TALLER',
      criticalMomentId: 2,
      extraConfigs: {
        maxValue: 5,
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGeneric',
      key: 'posventa-presupuesto',
      title: 'widgets.budgetPostventa',
      position: [1, 28],
      size: [1, 2],
      indicator: 'POSVENTA_PRESUPUESTO',
      criticalMomentId: 2,
      extraConfigs: {
        maxValue: 5,
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGeneric',
      key: 'posventa-garantia',
      title: 'widgets.warrantyPostventa',
      position: [2, 28],
      size: [1, 2],
      indicator: 'POSVENTA_GARANTIA',
      criticalMomentId: 2,
      extraConfigs: {
        maxValue: 5,
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'barByGeo',
      position: [0, 30],
      size: [4, 2],
      title: 'widgets.zonalSatisfaction',
      key: 'postventa-satisfaction-zona',
      indicator: 'POSVENTA_SATISFACCION',
      criticalMomentId: 2,
      extraConfigs: {
        colors: COLORS_CONFIG_BAR,
        itemsWidth: 200,
        percentageScale: false,
        decimals: 0,
      },
      extras: {
        groupByLevel: 2
      },
      render: (filters) => {
        return !isGeoLocationLeaf(filters, filtersData)
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'barByGeo',
      title: 'widgets.distribuidorSatisfaction',
      key: 'postventa-satisfaccion-dist',
      position: [0, 32],
      size: [4, 2],
      indicator: 'POSVENTA_SATISFACCION',
      criticalMomentId: 2,
      extraConfigs: {
        colors: COLORS_CONFIG_BAR,
        itemsWidth: 200,
        percentageScale: false,
        decimals: 0,
        rotateXAxisLegend: true,
        wrapTexts: true,
        labelFontSize: 10,
      },
      extras: {
        groupByLevel: 3
      },
      render: (filters) => {
        return !isGeoLocationLeaf(filters, filtersData)
      },
      mapper: (data: any) => {
        return [...data].sort((a: any, b:any) => b.value - a.value).map((item: any) => ({
          ...item,
          label: item.label !== undefined
            ? item.label.replaceAll('MITSUBISHI ', '')
            : item.label
        }))
      },
    }),
  ]
}

export default {
  title: 'Nacional Postventa Dashboard',
  description: 'Dashboard de Nacional Postventa',
  widgets: getAllWidgets,
} as DasboardConfig
